import { isEmptyOrNull } from "../../utils/DataUtils";

export const posDetailsInRequiredFormat = (posDetails: any, serviceType: any, posAddress: any, currentCountryName: any) => {
  const body = {
    posNo: posDetails.posNumber,
    storeName: posDetails.storeName,
    posType: posDetails.posType,
    billingPos: posDetails.billingPos,
    deliveredBy: posDetails.deliveredBy,
    fulfilledBy: posDetails.fulfilledBy,
    fulfillmentSystem: posDetails.fulfillmentSystem,
    virtualPos: posDetails.virtualPos,
    serviceType: !isEmptyOrNull(serviceType) ? serviceType.split(", ") : [],
    storeTimings: [],
    posContacts: [
      {
        id: posAddress.contactId ?? null,
        name: posAddress.contactName ?? "",
        email: posAddress.email ?? "",
        phoneNumber: !isEmptyOrNull(posAddress.contactNo) ? posAddress.contactNo : null,
      },
    ],
    posAddress: {
      id: posAddress.id,
      addressLine1: posAddress.addressLine1,
      addressLine2: posAddress.addressLine2,
      country: currentCountryName,
      region: posAddress.region,
      area: posAddress.area,
      street: posAddress.street,
      poBox: "",
      latitude: posAddress.latitude,
      longitude: posAddress.longitude,
    },
  };
  return body;
};

export const getPosAddress = (posDetails: any, currentCountryName: string) => {
  return {
    ...posDetails?.posContacts?.[0],
    ...posDetails?.posAddress,
    addressLine1: posDetails?.posAddress?.addressLine1 ?? "",
    addressLine2: posDetails?.posAddress?.addressLine2 ?? "",
    contactId: posDetails?.posContacts?.[0]?.id ?? 0,
    contactName: posDetails?.posContacts?.[0]?.name ?? "",
    email: posDetails?.posContacts?.[0]?.email ?? "",
    country: currentCountryName,
    contactNo: posDetails?.posContacts?.[0]?.phoneNumber ?? "",
    street: posDetails?.posAddress?.street ?? "",
    latitude: posDetails?.posAddress?.latitude ?? "",
    longitude: posDetails?.posAddress?.longitude ?? "",
    region: posDetails?.posAddress?.region ?? "",
    area: posDetails?.posAddress?.area ?? "",
    iso: currentCountryName,
  }
}